import _t from 'i18n!nls/personalization-settings';

export const EDIT_GOAL_REDIRECT_LAYER = 'edit-goal-redirect-layer';

export const EDIT_GOAL_REDIRECT_URL = 'edit-goal-redirect-url';

export const EDIT_GOAL_ENABLED_URL = 'personalization-settings';

export const INFERRED_VALUES_REVIEW_GATE = 'personalization-settings-inferred-review';

/**
 * Tab value used to register the Personalization tab in the account-settings
 * `Tabs` (mirrors account-settings `SettingsConstants.TopSections`). Defined
 * here so the mounting bundle (account-settings) and this bundle agree on the
 * value used for `<Tab value>` / `<TabPanel value>`.
 */
export const PERSONALIZATION_TOP_SECTION = 'Personalization';

/**
 * Query param account-settings reads to pick the active tab, e.g.
 * `/account-settings?tab=Personalization`. Lives here rather than in
 * account-settings so this bundle can build the URL without importing from the
 * bundle that already imports from it.
 *
 * The tab is a query param and not a fragment because a fragment never reaches
 * the server, so SSR would always render the default tab and visibly swap after
 * hydration.
 */
export const ACCOUNT_SETTINGS_TAB_QUERY_PARAM = 'tab';

/**
 * Single source of truth for the explicit Learner Object settings: each field's
 * id, its order in the card, and its label. A function (not a module constant)
 * so labels translate at render time and update on locale change. Per the tech
 * design these all map to READY LearnerObject mutations; data binding + per-field
 * editors land in later tickets.
 */
export const getLearnerObjectSettings = () =>
  [
    { id: 'learningGoal', label: _t('Learning goal') },
    { id: 'desiredRole', label: _t('Desired roles') },
    { id: 'skills', label: _t('Desired skills') },
    { id: 'currentRole', label: _t('Current role') },
    { id: 'educationLevel', label: _t('Highest level of education') },
  ] as const;

export type LearnerObjectFieldId = ReturnType<typeof getLearnerObjectSettings>[number]['id'];
